import React from "react";
import { Link } from "react-router-dom";
import './sass/_footer.sass';

function Footer() {
  return (
    <footer>
      <div className="divider">
        <Link to="mailto:hallo@marb.in">E-Mail</Link>
        {/* <Link to="https://marb.in/">Photography</Link> */}
        <Link to="https://www.linkedin.com/in/marbin-karaus-4712112b0/" target='external'>LinkedIn</Link>
      </div>
      <div>
        <p>© 2026 MARBIN KARAUS</p>
      </div>
    </footer>
  );
}

export default Footer;